// src/store/thunks/salesOrderThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSalesOrderInvioceApi,
  createSalesOrderApi,
  updateSalesOrderApi,
} from "../../../../apiservice/sales"; 
import { createSalesOrderPayload } from "../../../../utils/salesOrder";
import { postData } from "../../../../apiservice/apis";
import { fetchTagsOnEdit } from "../../../../store/commonThunks/lookups";

// 🔹 Fetch order number
export const fetchSalesOrderNumber = createAsyncThunk(
  "salesOrder/fetchSalesOrderNumber",
  async (val) => {
    const res = await getSalesOrderInvioceApi({ entryDate: val });
    return res.data;
  }
);

// 🔹 Create or Update order
export const createSalesOrder = createAsyncThunk(
  "salesOrder/createSalesOrder",
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState().salesOrder;
      const {authInfo} = getState().auth;

      // Build payload from Redux slice
      const payload = createSalesOrderPayload(state, authInfo);

      // Decide endpoint
      let res;
      if (state.sale_o_id) {
        // Update case
        res = await postData(`/sales/update-sales-order`, {
          ...payload,
          sale_o_id: state.sale_o_id,
        });

      } else {
        // Create case
        res = await postData(`/sales/create-sales-order`,payload);
      }

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const fetchSingleSalesOrder = createAsyncThunk(
  "salesOrder/fetchSingle",
  async (sale_o_id, { dispatch, rejectWithValue }) => {
    try {
      const res = await postData(
        "/sales/get-sales-order-record-with-details",
        { sale_o_id }
      );
      const order = res.data[0];

      // 🔹 fetch tags AFTER order loads
      const tags = await dispatch(
        fetchTagsOnEdit({
          tab_id: sale_o_id,
          type: "sales_order_entry"
        })
      ).unwrap();

      return {
        order,
        tags
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);